module.exports = "/assets/packs/images/ee6aaeb0e9271a2db61e7e6d7929e00a.png";